import * as v from 'valibot';
import { IdSchema } from './common';

export const AdminHierarchyRequest = v.object({
	areaId: v.nullable(IdSchema),
	regionId: IdSchema,
	territoryId: v.nullable(IdSchema),
});
